<div class="desktop">
    <div class="card mensaje">
        <div class="card-body">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1" style="width: 50px;">
                        <div class="linea"></div>
                        <img class="iconoinformacionCard" style="margin-top: 2px;" src="./assets/img/Icons_SM.svg">
                    </div>
                    <div class="col">
                        <h3 class="proceso"><span>En caso de reclamación:</span> El número de matrícula inmobiliaria debe coincidir
                            con el del inmueble asegurado.</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modile">
    <div class="card mensaje">
        <div class="card-body">
            <div class="container">
                <div class="row">
                    <div class="col-auto">
                        <div class="linea"></div>
                        <img class="iconoinformacionCard" src="./assets/img/Icons_SM.svg">
                    </div>
                    <div class="col">
                        <div class="proceso">En caso de reclamación: </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="detalleMobile">
                            El número de matrícula inmobiliaria debe coincidir
                            con el del inmueble asegurado.
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>